<script>
  import M from "materialize-css";
  import axios from "axios";

  let input = {
    blogId: "",
    postingId: "",
    title: "",
    content: "",
    image: "",
    imageName: ""
  };

  let link = null;

  let test = "";

  let bindImage = function(event) {
    let file = event.srcElement.files[0];
    if (!/^image\/\w+/.test(file.type)) {
      M.toast({ html: "이미지만 등록 가능합니다." });
      event.srcElement.value = null;
      input.imageName = "";
      return false;
    }

    let reader = new FileReader();
    reader.onload = function(event) {
      input.image = event.target.result;
      input.imageName = file.name;
    };
    reader.readAsDataURL(file);
  };

  let submitForm = function() {
    let params = new URLSearchParams();
    Object.keys(input).map(function(key) {
      params.append(key, input[key]);
    });

    axios
      .post("./api/add_post.php", params)
      .then(function(response) {
        if (!response.data.success) {
          M.toast({ html: response.data.data.message });
        } else {
          link =
            "https://blog.naver.com1.kr/" +
            input.blogId +
            "/" +
            input.postingId;
          input.blogId = "";
          input.postingId = "";
          input.title = "";
          input.content = "";
          input.imageName = "";
          document.getElementById("image-file").value = null;

          M.toast({ html: "링크가 생성되었습니다!" });
        }
      })
      .catch(function(error) {
        M.toast({ html: "생성에 실패하였습니다." });
      });
  };

  let copyLink = function() {
    if (link === null) {
      M.toast({ html: "아직 링크가 생성되지 않았습니다." });
      return false;
    }
    let textarea = document.createElement("textarea");
    textarea.value = link;

    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, 9999); // 추가

    document.execCommand("copy");
    document.body.removeChild(textarea);
    M.toast({ html: "복사되었습니다. 원하는 곳에 붙여넣어보세요!" });
  };
</script>

<style>
  .body {
    margin-top: 2rem;
  }

  input:required + label:before {
    display: inline-block;
    margin-right: 5px;
    content: "*";
  }
  i.copy-icon {
    font-size: 24px;
    vertical-align: middle;
  }
  span.link {
    color: #039be5;
    cursor: pointer;
  }
</style>

<nav>
  <div class="nav-wrapper">
    <div class="container">
      <a href="./" class="brand-logo">naver.blog 낚시 링크 만들기</a>
    </div>
  </div>
</nav>
<div class="body">
  <div class="container">
    <div class="row">
      <div class="input-field col s12 m6">
        <input
          type="text"
          id="blog-id"
          placeholder="ex) skfnxh123"
          bind:value={input.blogId}
          required />
        <label for="blog-id">블로그 ID</label>
      </div>
      <div class="input-field col s12 m6">
        <input
          type="number"
          id="posting-id"
          placeholder="ex) 105023412"
          bind:value={input.postingId}
          required />
        <label for="posting-id">포스팅 ID</label>
      </div>
      <div class="input-field col s12">
        <input
          type="text"
          id="title"
          placeholder="ex) 경기도 재난기본소득 신청 방법!"
          bind:value={input.title}
          required />
        <label for="title">제목</label>
      </div>
      <div class="input-field col s12">
        <textarea
          id="content"
          class="materialize-textarea"
          placeholder="ex) 경기도가 지급을 결정한 재난기본소득의"
          bind:value={input.content} />
        <label for="content">내용</label>
      </div>
      <div class="file-field input-field col s12">
        <div class="btn">
          <span>이미지 업로드</span>
          <input type="file" on:change={bindImage} id="image-file" />
        </div>
        <div class="file-path-wrapper">
          <input
            class="file-path validate"
            type="text"
            bind:value={input.imageName} />
        </div>
      </div>
      <div class="col s12 center-align">
        <button
          class="btn red accent-3 waves-effect waves-light"
          on:click={submitForm}>
          낚시 링크 만들기
        </button>
      </div>
    </div>
    {#if link != null}
      <div class="link">
        <div class="card">
          <div class="card-content center-align">
            <span class="link" on:click={copyLink}>
              {link}
              <i class="material-icons copy-icon">content_copy</i>
            </span>
          </div>
        </div>
      </div>
    {/if}
  </div>
</div>
